import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga';
import { RootSaga } from '.';
import { combineReducers } from 'redux'
import { ConfigReducer } from './config/reducer';
import { CeclApiReducer } from './ceclapi/reducer';
import { UserManagementReducer } from './user-management/reducer';

export const lastAction = (state = null, action: any) => {
    return action;
};

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: combineReducers({
        config: ConfigReducer,
        cecl: CeclApiReducer,
        lastAction,
        userManagement: UserManagementReducer,
    }),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({immutableCheck: false, serializableCheck: false}).concat(sagaMiddleware)
})

sagaMiddleware.run(RootSaga);